import {FAILURE, PENDING, SUCCESS, RESET} from '../../constants'
import {getCalendarSearchApi} from '../../../services/entities'

export async function searchCalendar(dispatch, entity_id, params, viewData) {
  if (params.query === '') {
    dispatch({type: RESET})
  } else {
    try {
      dispatch({type: PENDING, payload: {...params}})
      let response = await getCalendarSearchApi(entity_id, params)
      dispatch({type: SUCCESS, payload: {...response, ...params, viewData}})
      return response
    } catch (e) {
      console.log(`Get Reservation Entity Items Failed: ${entity_id}`)
      dispatch({type: FAILURE, payload: e})
      return Promise.reject(e)
    }
  }
}
